import { gql } from '@apollo/client';
export const loanListItemFragment = gql `
  fragment loanListItemFields on LoanEntity {
    id
    currentLtv
    marginCallLtv
    currentLoanAmount
    initialLoanAmount
    initialCollateralAmount
    currentCollateralPrice
    currentCollateralAmount
    currentCollateralAssetPrice
    status
  }
`;
export const loanFragment = gql `
  fragment loanFields on LoanEntity {
    ...loanListItemFields
    status
    createdAt
    initialLtv
    interestRate
    loanPrincipal
    liquidationLtv
    minimumInterestPeriod
  }

  ${loanListItemFragment}
`;
export const loanPaymentFragment = gql `
  fragment loanPaymentFields on LoanPaymentEntity {
    id
    amount
    interest
    principal
    createdAt
    releasedCollateral
    releasedCollateralWithdrawn
  }
`;
//# sourceMappingURL=loan.js.map